import { actions, mutations } from './types';
import { ErrorNotification, SuccessNotification } from './notifications';

export default {
  /**
   *  Notify
   * @param {function} commit
   * @param {object} notification Notifcation obect with a type and message
   * key. Type can be 'success' or 'error' to determine the kind of toast.
   */
  [actions.NOTIFY]({ commit }, notification = null) {
    commit(mutations.SET_NOTIFICATION, notification);
    commit(mutations.SET_NOTIFY, notification !== null);
  },
  [actions.NOTIFY_SUCCESS]({ dispatch }, message) {
    const notification = new SuccessNotification(message);
    dispatch(actions.NOTIFY, notification);
  },
  [actions.NOTIFY_ERROR]({ dispatch }, message) {
    const notification = new ErrorNotification(message);
    dispatch(actions.NOTIFY, notification);
  },
};
